import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ReportModel } from "../../shared/classes/ReportModel";
import { ReportsService } from '../../shared/services/reports.service';
import { PaginationInstance } from "ngx-pagination";
import { ConsultaService } from "../../shared/services/consulta.service";
import { DadosConsultaModel } from "../../shared/classes/DadosConsultaModel";
import { RetornoConsultaModel } from "../../shared/classes/RetornoConsultaModel";
import { Adal4Service } from "adal-angular4";
import { Router, NavigationExtras } from "@angular/router";

@Component({
  selector: 'app-consultar-dados',
  templateUrl: './consultar-dados.component.html',
  styleUrls: ['./consultar-dados.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ConsultarDadosComponent implements OnInit {
  
  selectedReport: ReportModel = new ReportModel();
  msgAviso: string;
  class_fa_icon_ok = "fa fa-thumbs-o-up fa-3x text-success";
  class_fa_icon_nok = "fa fa-thumbs-o-down fa-3x text-error";
  class_icon_msg: string;
  retornoConsulta: RetornoConsultaModel; // = new RetornoConsultaModel();
  id: number;
  @Input('data') listaReports: ReportModel[] = [];
  mostrarCarregando = false;
  idRelatorioSelecionado: number = -1;  
  pageSize: number = 100;
  pageNumber: number = 1;
  canDecrement = false;
  canIncrement = false;
  showFiltersSection = false;
  noDataMsg : string;
  //paginação relatorios
  public filter: string = '';
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  mostrarExportando = false;
  mostrarObtendoDados = false;
  isFirefox_ : boolean = false;
  changeDatePicker_: boolean = false;
 
  public config: PaginationInstance = {
    id: 'advanced',
    itemsPerPage: 1000000,
    currentPage: 1   
  };

  // public labels: any = {
  //   previousLabel: 'Anterior',
  //   nextLabel: 'Próxima',
  //   screenReaderPaginationLabel: 'Pagination',
  //   screenReaderPageLabel: 'page',
  //   screenReaderCurrentLabel: `You're on page`
  // };
  constructor(private adalService: Adal4Service, private router: Router, private _reportService: ReportsService, private _consultaService: ConsultaService) { }

  ngOnInit() {
    this.isFirefox_ = navigator.userAgent.indexOf("Firefox") >= 0;
    if (this.isFirefox_){
      let ua = navigator.userAgent;
      let versaoFirefox = ua.substr(ua.length - 3);
      //alert("is firefox");
      if(Number(versaoFirefox) < 58){
        this.changeDatePicker_ = true;
      }
    }
    this.disableNextPrevButtons();
    this.mostrarCarregando = true;
    this._reportService.getReports()
      .then(reports => {        
        this.listaReports = reports;
        this.mostrarCarregando = false;
      }).catch(error => {
        this.mostrarCarregando = false;
        this.msgAviso = error.text();// || <any>error;
        if(error.status == 403 || error.status == 401){
          this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
          //this.router.navigate(['/home']);           
        }
        this.class_icon_msg = this.class_fa_icon_nok;
        document.getElementById("showMensagensModal3").click();
      });
    this.resetSelectedReport();
  }

  
  getSelectedReportData(){
    this.noDataMsg = "";
    if(this.idRelatorioSelecionado > -1){      
      var reportId = this.idRelatorioSelecionado;
      var reportHasFilters = this.getReportFromListById(reportId).hasFilters;
      if(reportHasFilters){
         this.disableNextPrevButtons();
         this.initializeSelectedReport(this.idRelatorioSelecionado).then(() => {              
            this.showFiltersSection = true;   
            if(this.retornoConsulta){
              this.retornoConsulta = null;
            } 
        }) 
      }else{
          this.mostrarObtendoDados = true;
          this.initializeSelectedReport(this.idRelatorioSelecionado);
          var dadosConsulta = this.initializeDadosConsulta(false)
          this.getData(dadosConsulta);
          this.showFiltersSection = false;
        }
           
    }    
  }

  getFirstPageDataWithFilters(){
    this.pageNumber = 1;
    this.getReportDataWithFilters();
  }

  getFirstPagetData(){
    if(this.idRelatorioSelecionado > -1){
      this.pageNumber = 1;
      this.getSelectedReportData();
    }
  }  
 
  capitalizeFilterName(palavra: string) : string {
    return palavra.charAt(1).toUpperCase() + palavra.slice(2);
  }

  getReportDataWithFilters(){    
    
    var dadosConsulta = this.initializeDadosConsulta(true);
    var canProcede = true;
    dadosConsulta.reportFilters.forEach(filtro => {
      //console.log("filtro.filterValue",filtro.filterValue);
      if(filtro.isRequired && !filtro.filterValue){
        canProcede = false;
      }     
    });
    if(!canProcede){     
      this.msgAviso = "Favor preencher todos os filtros obrigatórios";
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal3").click();
      return;
    }    
    this.getData(dadosConsulta);
  }

  getData(dadosConsulta : DadosConsultaModel){
    this.noDataMsg = null;
    this.mostrarObtendoDados = true;

    this._consultaService.getReportData(dadosConsulta).then(retorno => {
      this.retornoConsulta = retorno;
      if (this.retornoConsulta.valuesGroups.length < this.pageSize && this.pageNumber == 1) {
        localStorage.setItem("dadosExport", JSON.stringify(this.retornoConsulta));
      }
      this.setCanIncrement();    
      this.setCanDecrement(); 
      this.mostrarObtendoDados = false; 
    }).catch(error => {
      this.mostrarObtendoDados = false; 
      this.msgAviso = error.text() || <any>error;
      if (this.msgAviso.indexOf("parâmetros informados") > -1){
        this.retornoConsulta = null;
        this.canIncrement = false;
        this.noDataMsg = this.msgAviso;
        return;
      }
      if(error.status == 403 || error.status == 401){
        this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
        //this.router.navigate(['/home']);           
      }
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal3").click();
    });
  }

  getNextPage(){
    if(this.canIncrement){
      this.pageNumber = this.pageNumber + 1;
      if(this.selectedReport.hasFilters){
        this.getReportDataWithFilters();
        return;
      }
      this.getSelectedReportData();
    }   
  }

  getPreviousPage(){    
    if(this.canDecrement){
      this.pageNumber = this.pageNumber - 1;
      if(this.selectedReport.hasFilters){
        this.getReportDataWithFilters();
        return;
      }
      this.getSelectedReportData();
    }   
  }

  setCanIncrement(){
    if(this.retornoConsulta.valuesGroups.length < this.pageSize){
      this.canIncrement = false;
      this.disableNextButton();
    }else{
      this.canIncrement = true;
      this.enableNextButton();
    }
  }

  setCanDecrement(){
    if(this.pageNumber == 1){
      this.canDecrement = false;
     this.disablePreviousButton();
    }else{
      this.canDecrement = true;
      this.enablePreviousButton();
    }
  }

  exportToExcel(){
    this.mostrarExportando = true;
    var reportHasFilters = this.getReportFromListById(this.idRelatorioSelecionado).hasFilters;
    var dadosConsulta = this.initializeDadosConsulta(reportHasFilters);
    dadosConsulta.pageNumber = 0;

    if(localStorage.getItem("dadosExport")){
      console.log("dadosExport foi setado");
      let rcvm = JSON.parse(localStorage.getItem("dadosExport"));
      
      this._consultaService.exportExcelSlim(rcvm, dadosConsulta.reportName).then(url => {
        this.mostrarExportando = false;      
        window.open(url);
      }).catch(error => {
        this.hadleError(error);
      });
      localStorage.removeItem("dadosExport");
      return;
    }    
    
    this._consultaService.exportExcel(dadosConsulta).then(url => {
      this.mostrarExportando = false;      
      window.open(url);
    }).catch(error => {
      this.hadleError(error);
    });
  }

  private hadleError(error: any) {
    this.mostrarExportando = false;
    this.msgAviso = error.text(); // || <any>error;
    if (error.status == 403 || error.status == 401) {
      this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
      //this.router.navigate(['/home']);           
    }
    this.class_icon_msg = this.class_fa_icon_nok;
    document.getElementById("showMensagensModal3").click();
  }

  initializeDadosConsulta(hasFiltes: boolean) : DadosConsultaModel{
    var dadosConsulta = new DadosConsultaModel();
    dadosConsulta.idReport = this.selectedReport.id;
    dadosConsulta.reportName = this.selectedReport.reportTitle;
    dadosConsulta.orderByField = "id";
    dadosConsulta.pageNumber = this.pageNumber;
    dadosConsulta.pageSize = this.pageSize;
    if(!hasFiltes){      
      dadosConsulta.reportFilters = [];
    }else{
      dadosConsulta.reportFilters = this.selectedReport.reportFilters; 
           
    }  
    return dadosConsulta;
  }

  initializeSelectedReport(reportId: number){    
    //this.resetSelectedReport();
    this.selectedReport = this.getReportFromListById(reportId);
    if(this.selectedReport.hasFilters){         
         return this._reportService.getReportById(reportId)
        .then(report => {        
          // this.selectedReport.reportQuery = report.reportQuery;
          report.reportFilters.forEach(filtro => {
            filtro.filterName = this.capitalizeFilterName(filtro.filterName);
          });
          this.selectedReport.reportFilters = report.reportFilters;      
          this.selectedReport.reportTitle = report.reportTitle; 
        }).catch(error => {
          this.msgAviso = error.text();// || <any>error;
          if(error.status == 403 || error.status == 401){
            this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
            //this.router.navigate(['/home']);           
          }
          this.class_icon_msg = this.class_fa_icon_nok;
          document.getElementById("showMensagensModal3").click();
        })
    }   
  }
  
  getReportFromListById(idReport: number) : ReportModel{
    var reports =  this.listaReports.filter(r => r.id == idReport);
    if (reports.length > 0){
      return reports[0];
    }
    return null;
  }
  
  resetSelectedReport() {
    //console.log("Chamou resetSelectedReport");
    this.selectedReport.reportTitle = "Carregando..";
    this.selectedReport.reportQuery = "";
    this.selectedReport.reportFilters = [];
  }  

  disableNextPrevButtons(): void {
    //(<HTMLInputElement> document.getElementById("prev1")).disabled = true;
    (<HTMLInputElement> document.getElementById("prev2")).disabled = true;
    //(<HTMLInputElement> document.getElementById("next1")).disabled = true;
    (<HTMLInputElement> document.getElementById("next2")).disabled = true;
  }

  disableNextButton(): void{
    (<HTMLInputElement> document.getElementById("next2")).disabled = true;
  }

  disablePreviousButton(): void{
    (<HTMLInputElement> document.getElementById("prev2")).disabled = true;
  }

  enableNextButton(): void{
    //(<HTMLInputElement> document.getElementById("next1")).disabled = true;
    (<HTMLInputElement> document.getElementById("next2")).disabled = false;
  }

  enablePreviousButton(): void{
    //(<HTMLInputElement> document.getElementById("prev1")).disabled = true
    (<HTMLInputElement> document.getElementById("prev2")).disabled = false;
  }

}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/paginas/consultar-dados/consultar-dados.component.ts